import useEventListener from 'app/hooks/useEventListener';

const useClickOutside = (
  ref: React.MutableRefObject<HTMLElement | null>,
  secondRef: React.MutableRefObject<HTMLElement | null>,
  cb: (...arg: any) => void,
): void => {
  useEventListener(
    'click',
    e => {
      if (
        ref.current == null ||
        ref.current.contains(e.target) ||
        secondRef.current == null ||
        secondRef.current.contains(e.target)
      )
        return;
      cb(e);
    },
    document,
  );
};

export default useClickOutside;
